import { SESSION_STORAGE_KEYS } from "../constants/sessionStorage.constants";

export const generateUserId = (): string => {
  return crypto.randomUUID();
};

export const getUserId = (): string => {
  let userId = sessionStorage.getItem(SESSION_STORAGE_KEYS.USER_ID);

  if (!userId) {
    userId = generateUserId();
    sessionStorage.setItem(SESSION_STORAGE_KEYS.USER_ID, userId);
  }

  return userId;
};
